import script from "./GeneralSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralSettings.vue?vue&type=script&setup=true&lang=js"

import "./GeneralSettings.vue?vue&type=style&index=0&id=74ca47ea&lang=scss"

const __exports__ = script;

export default __exports__